import type { IconName } from '@sweetgreen/garnish';

import type { BraintreeCardType, CardType } from '../graphql/types';

export const CREDIT_CARDS_ICONS: Record<Index, IconName> = {
  VISA: 'IconCcVisa',
  MASTER_CARD: 'IconCcMasterCard',
  DISCOVER: 'IconCcDiscover',
  AMEX: 'IconCcAmex',
  AMERICAN_EXPRESS: 'IconCcAmex',
  NEW: 'IconCreditCard',
};

export const BRAINTREE_CREDIT_CARDS_ICONS: Record<BraintreeCardType, IconName> =
  {
    AmEx: 'IconCcAmex',
    CarteBlanche: 'IconCreditCard',
    ChinaUnionPay: 'IconCreditCard',
    DinersClubInternational: 'IconCreditCard',
    Discover: 'IconCcDiscover',
    Elo: 'IconCreditCard',
    JCB: 'IconCreditCard',
    Laser: 'IconCreditCard',
    Maestro: 'IconCreditCard',
    MasterCard: 'IconCcMasterCard',
    Solo: 'IconCreditCard',
    Switch: 'IconCreditCard',
    UKMaestro: 'IconCreditCard',
    Visa: 'IconCcVisa',
    Unknown: 'IconCreditCard',
  };

type Index = CardType | 'NEW';
